export const ARTIST_COLLECTION = 'artists'
export const ESCALERAS_ALLOW_LIST_COLLECTION = 'escalerasAllowList'
export const FRASES_COLLECTION = 'frases'
export const PALABRAS_COLLECTION = 'palabrasRoundSignatures'
export const PALABRAS_ALLOW_LIST_COLLECTION = 'palabrasAllowList'
export const PROJECT_COLLECTION = 'projects'
export const TEST_COLLECTION = 'Tests'
export const TOKEN_COLLECTION = 'tokens'
export const WHITELIST_COLLECTION = 'whitelistedAddresses'
